import s from '../docs.module.css'
import DocsSecondTableTC from "./DocsSecondTable.jsx";
import RadioGroup from '../../baseComponents/RadioGroup';
import SaveStatus from '../../../UIComponents/SaveStatus'

import ReportTable from '../../../Components/ReportBody/ReportTable.jsx'
import VisitsTable from '../../../Components/VisitsTable';
import {memo} from "react";

const DocsSecondRight = (props) => {
    const {
        geoObjReport,
        workingTimeSheet,
        geoObjVisits,
        geoObjReport:{data:geoObbjData=[]}={},
        workingTimeSheet:{data:workingTimeSheetData=[]}={},
        geoObjVisits:{data:geoObjVisitsData=[]}={},
    } = props

    return (
        <div className={s.docsContainer} style={{ width: "100%" }}>
            <RadioGroup />
            <div className={s.secondRightConrainer}>
                <div className={s.contentContainer}>
                    <SaveStatus errShowTime={1000} successShowTime={500} dataObj={workingTimeSheet} title="Загрузка табеля"/>
                </div>
                <div className={s.contentContainer}>
                    <SaveStatus errShowTime={1000} successShowTime={500} dataObj={geoObjReport} title="Загрузка данных"/>
                </div>
                <div className={s.contentContainer}>
                    <SaveStatus errShowTime={1000} successShowTime={500} dataObj={geoObjVisits} title="Загрузка данных о посещении геозон"/>
                </div>
            </div>

            <div className={s.secondRightConrainer}>
                <div className={s.contentContainer}>
                    {geoObbjData.map((widget) => (
                        <div className={s.containerItem}>
                            <DocsSecondTableTC {...widget} />
                        </div>
                    ))}
                </div>
            </div>

            {workingTimeSheetData.length ? (
                <div className={s.secondRightConrainer}>
                    <div className={s.contentContainer}>
                        <ReportTable data={workingTimeSheetData} disableFull/>
                    </div>
                    {/* <BodyRight /> */}
                </div>
            ) : null}

            {geoObjVisitsData?.length ? (
                <div className={s.secondRightConrainer}>
                    <div className={s.contentContainer}>
                        <VisitsTable data={geoObjVisitsData} />

                    </div>
                    {/* <BodyRight /> */}
                </div>
            ) : null}

        </div>
    );
};


export default memo(DocsSecondRight);